import { combineReducers } from 'redux';
import lessons from './lesson.reducer';

const lessonAppReducer = combineReducers({
    lessons,
});

export default lessonAppReducer;


// WEBPACK FOOTER //
// src/main/content/lesson/store/reducers/index.js